angular.module('natura')
  .controller(
  'PggEditController', [
    '$scope',
    '$sce',
    '$uibModal',
    '$log',
    'pggEditProvider',
    'pggMapProvider',
    'pggLayerProvider',
    'pggJstsProvider',
    'pggStyleProvider',
    'pggInteractionsProvider',
    'pggAdatlapProvider',
    'pggEloirasProvider',
    'pggSearchProvider',
    function ($scope, $sce, $uibModal, $log, pggEditProvider, pggMapProvider, pggLayerProvider, pggJstsProvider,
      pggStyleProvider, pggInteractionsProvider, pggAdatlapProvider, pggEloirasProvider, pggSearchProvider) {
      $scope.map = this.map;

      this.modalShown = false;

      var selectedCollection = new ol.Collection();
      var jsts = pggJstsProvider.getConfig();
      // var styles = pggStyleProvider.getStyles();

      $scope.alerts = [];

      $scope.selectedTabIdx = 0;

      $scope.userCanEdit = pggEditProvider.getUserCanEdit();

      $scope.closeAlert = function (index) {
        $scope.alerts.splice(index, 1);
      };

      $scope.eloirasOptions = null;
      pggEloirasProvider.getOptionsParametersPromise().then(
        function (data) {
          if (data.status == 200 && data.statusText == "OK") {
            pggEloirasProvider.setOptions(data.data);
            $scope.eloirasOptions = pggEloirasProvider.getOptions();
          } else {
            $log.error("Hiba történt az előírások legördülő " +
              "lekérdezés során (pggEloirasProvider.getOptionsParametersPromise)");
            $log.error(data);
          }
        });

      $scope.eloiras_table_dirty = false;
      $scope.hoverLayer = null;

      $scope.tooltips = {
        drawNewElement: $sce.trustAsHtml("Új elem<br />rajzolása"),
        modifyElement: $sce.trustAsHtml("Elem kijelölése,<br />módosítása"),
        removeElement: $sce.trustAsHtml("Elem<br />törlése"),
        cancel: $sce.trustAsHtml("Módosítások<br />elvetése"),
        update: $sce.trustAsHtml("Módosítások<br />mentése"),
        save: $sce.trustAsHtml("Módosítások<br />mentése"),
        dontSave: $sce.trustAsHtml("Nincs<br />mentés"),
        showDatasheet: $sce.trustAsHtml("Adatlap<br />megnyitása"),
        showRemoveDatasheet: $sce.trustAsHtml("Adatlap<br />törlése"),
        mainData: $sce.trustAsHtml("Alapadatok"),
        datasheets: $sce.trustAsHtml("Adatlapok"),
        restrictions: $sce.trustAsHtml("Előírások"),
        geometry: $sce.trustAsHtml("Geometria")
      };

      pggEditProvider.setScope($scope);
      pggEditProvider.setJsts(jsts);
      // pggEditProvider.setStyles(styles);

      $scope.innerRing = {
        checked: false
      };

      var layers = $scope.map.getLayers().getArray();
      for (var i = 0; i < layers.length; i++) {
        if (layers[i] instanceof ol.layer.Vector) {
          $scope.editLayer = layers[i];
          pggEditProvider.setEditLayer($scope.editLayer);
          break;
        }
      }

      $scope.selectedElements = [];
      $scope.newFeatures = [];

      $scope.draw = {
        snap: {
          value: true,
          opts: [{
            name: "Pontos illesztés (snap)",
            value: true
          }, {
              name: "Nincs pontos illesztés",
              value: false
            }]
        },
        forced: {
          value: true,
          opts: [{
            name: "Meglévő elemmel ír felül",
            value: false
          }, {
              name: "Új elemmel ír felül",
              value: true
            }]
        }
      };

      pggEditProvider.createDraw('MultiPolygon');
      pggInteractionsProvider.addInteraction(pggEditProvider.getDraw());
      pggEditProvider.getDraw().setActive(false);

      pggEditProvider.createModify();
      pggInteractionsProvider.addInteraction(pggEditProvider.getSelectAndModify());
      pggEditProvider.getSelectAndModify().setActive(false);

      pggEditProvider.createSnap();
      pggEditProvider.getSnap().setActive(true);

      $scope.interactions = {
        draw: pggEditProvider.getDraw(),
        modify: pggEditProvider.getSelectAndModify(),
        snap: pggEditProvider.getSnap()
      };

      this.draw = function () {
        if ($scope.interactions.draw.getActive()) {
          pggInteractionsProvider.deactivateInteraction($scope.interactions.draw);
        } else {
          pggInteractionsProvider.activateInteraction($scope.interactions.draw);
        }
        $scope.interactions.modify.clearFeatures();
      };

      this.modify = function () {
        if ($scope.interactions.modify.getActive()) {
          pggInteractionsProvider.deactivateInteraction($scope.interactions.modify);
          $scope.interactions.modify.clearFeatures();
        } else {
          pggInteractionsProvider.activateInteraction($scope.interactions.modify);
        }
      };

      this.toggleSnap = function (value) {
        $scope.interactions.snap.setActive(value);
      };

      this.toggleHoleDraw = function () {
        $scope.interactions.modify.setHoleDrawActive($scope.innerRing.checked);
      };

      pggAdatlapProvider.populateOptions();

      $scope.openDatasheet = function (size, datasheet) {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'assets/terkep/app/modal/modalContent.html',
          controller: 'PggModalInstanceCtrl',
          size: size,
          backdrop: 'static',
          resolve: {
            feature: function () {
              return $scope.selectedElements[0].feature;
            },
            datasheet: function () {
              return datasheet;
            },
            userCanEdit: function () {
              return $scope.userCanEdit;
            }
          }
        });
        modalInstance.result.then(function (selected) {
          // ha új adatlap van, annak még nincs id-je
          if (selected.id === null) {
            // új adatlap feltöltése
            pggAdatlapProvider.postDatasheetPromise(selected).then(
              function (data) {
                if (data.data.success === true && data.data.affected.length > 0) {
                  // adatlapok újbóli lekérése
                  pggAdatlapProvider.getDatasheetsByFeatureIdPromise(
                    $scope.selectedElements[0].feature.getProperties().id).then(function (data) {
                      $scope.selectedElements[0].datasheets = data.data.datasheets;
                    });
                  $scope.alerts.push({
                    type: 'success',
                    msg: 'Az adatlap rögzítése sikerült.'
                  });
                } else {
                  $log.error("Valami baj történt az adatlap elmentése során");
                  $log.error(data);
                  $scope.alerts.push({
                    type: 'danger',
                    msg: 'Hiba történt az adatlap elmentése során'
                  });
                }
              });
          } else {
            // meglévő adatlap módosítása
            pggAdatlapProvider.putDatasheetPromise(selected).then(
              function (data) {
                if (data.data.success === true && data.data.affected.length > 0) {
                  // módosított adatlap újbóli lekérése
                  pggAdatlapProvider.getDatasheetByFeatureIdAndAdatlapIdPromise(
                    $scope.selectedElements[0].feature.getProperties().id, selected.id).then(
                    function (data) {
                      // régi adatlap lecserélése az újra
                      var updatedDatasheet = data.data.datasheets[0];
                      for (var i = 0; i < $scope.selectedElements[0].datasheets.length; i++) {
                        if ($scope.selectedElements[0].datasheets[i].id == updatedDatasheet.id) {
                          $scope.selectedElements[0].datasheets[i] = updatedDatasheet;
                          $scope.alerts.push({
                            type: 'success',
                            msg: 'Az adatlap módosítása sikerült.'
                          });
                          break;
                        }
                      }
                    });
                } else {
                  $log.error("Valami baj történt az adatlap módosítása során");
                  $log.error(data);
                  $scope.alerts.push({
                    type: 'danger',
                    msg: 'Hiba történt az adatlap módosítása során'
                  });
                }
              });
          }
        }, function () { });
      };

      $scope.deleteDatasheet = function (size, datasheet) {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'assets/terkep/app/modal/deleteDatasheetModal.html',
          controller: 'PggDeleteDatasheetModalController',
          size: size,
          backdrop: 'static',
          resolve: {}
        });
        modalInstance.result.then(function () {
          pggAdatlapProvider.deleteDatasheetPromise(datasheet).then(function (data) {
            if (data.data.success === true) {
              for (var i = 0; i < $scope.selectedElements[0].datasheets.length; i++) {
                if ($scope.selectedElements[0].datasheets[i].id == datasheet.id) {
                  $scope.selectedElements[0].datasheets.splice(i, 1);
                  $scope.alerts.push({
                    type: 'success',
                    msg: 'Az adatlap törlése sikerült.'
                  });
                }
              }
            } else {
              $log.error("Valami baj történt az adatlap törlése során");
              $log.error(data);
              $scope.alerts.push({
                type: 'danger',
                msg: 'Hiba történt az adatlap törlése során'
              });
            }
          });
        }, function () { });
      };

      /*****************************************************************
       * ELŐÍRÁSOK
       ****************************************************************/
      /**
       * Előírásnál egy legördülő módosítása során állítsa módosítottra
       * az egész elemet (update vagy cancel)
       */
      $scope.setEloirasDirty = function () {
        $scope.eloiras_table_dirty = true;
        $scope.editForm.eloiras_table.$dirty = true;
      };
      /**
       * Megmutatja a térképen az egérrel adott kezelési egység fölé
       * vitt elemet
       */
      $scope.showHoverLayer = function (kezelesiEgyseg) {
        var format = new ol.format.GeoJSON();
        var feature = format.readFeature(kezelesiEgyseg.geojson);
        var vectorSource = new ol.source.Vector({});
        vectorSource.addFeature(feature);
        $scope.hoverLayer = new ol.layer.Vector({
          source: vectorSource,
          style: pggStyleProvider.getHoverStyleByFeature
        });
        pggLayerProvider.addLayerWithZMax($scope.hoverLayer, pggLayerProvider.getNextZMax());
      };
      /**
       * Eltünteti (leszedi) az előírásoknál létrehozott hover réteget
       */
      $scope.hideHoverLayer = function () {
        pggMapProvider.getMap().removeLayer($scope.hoverLayer);
      };
      /**
       * Dinamikusan állítja be az előírások táblázatnál az adott sor
       * hátterének a színét
       */
      $scope.eloirasStyleFunction = function (eloiras, options) {
        // ha legördülőből választ, akkor mindenképp azt vegye
        // figyelembe
        if (eloiras.selected) {
          return eloiras.selected.key;
        } else {
          // ha még nem volt választás a legördülőből, akkor színezze ki
          // az
          // adatbázisból érkező érték szerint
          for (var i = 0; i < options.length; i++) {
            if (eloiras.declaration_id == options[i].id) {
              eloiras.selected = options[i];
              return eloiras.selected.key;
            }
          }
        }
      };

      /**
       * Összeszedi, mely előírásokban történt változás
       */
      this.getModifiedEloirasok = function () {
        var modifiedEloirasok = {
          declarations: []
        };
        if ($scope.editForm.eloiras_table.$dirty) {
          // végig kell menni az egyes kezelési egységeken, illetve azok
          // children elemein
          angular.forEach($scope.selectedElements[0].eloirasok, function (kezelesiEgyseg) {
            angular.forEach(kezelesiEgyseg.children, function (eloiras) {
              // ha az előírás kezdeti értéke (declaration_id) nem
              // egyezik meg a
              // legördülő értékével (selected.id), akkor be kell tenni
              // a
              // küldendő tömbbe
              if (eloiras.declaration_id != eloiras.selected.id) {
                // a json tartalma megfelel a
                // {{url}}/szabalyok/elfogadasa
                // hívásához szükséges paramétereknek
                modifiedEloirasok.declarations.push({
                  obj: eloiras,
                  geometry_id: eloiras.geom_id,
                  rule_id: eloiras.rule_id,
                  declaration_id: eloiras.selected.id
                });
              }
            });
          });
        }
        return modifiedEloirasok;
      };

      $scope.tabSelect = function (idx) {
        $scope.selectedTabIdx = idx;
        $scope.getEloirasok(false);
      };

      // azt figyeli, mikor történik új elem kijelölése
      $scope.$watch(function (scope) {
        return scope.selectedElements;
      }, function (newValue, oldValue) {
        // állítsa az első tab-ot aktívra
        $scope.activeTab = 0;
        // lekérdezi az előírásokat, ha szükséges
        // if ($scope.selectedElements && $scope.selectedElements[0]) {
        // $scope.getEloirasok(false);
        // }
      });

      $scope.getEloirasok = function (forceUpdate) {
        if ($scope.selectedTabIdx == 2 &&
          (!$scope.selectedElements[0].hasOwnProperty("eloirasok") || forceUpdate)) {
          var feature = $scope.selectedElements[0].feature;
          pggEloirasProvider.getMetszetEloirasByFeatureIdArrayPromise([feature.getProperties().id]).then(
            function (data) {
              var eloirasok = data.data.data;
              pggEloirasProvider.getMetszetByFeatureIdPromise(feature.getProperties().id).then(
                function (data2) {
                  var metszetek = data2.data.geojson;
                  $scope.selectedElements[0].eloirasok = pggEloirasProvider
                    .extractEloirasokByKezelesiEgyseg(eloirasok, metszetek);
                });
            });
        }
      };

      $scope.refreshEloirasColorByDeclarationId = function (declarationId, eloiras) {
        for (var o = 0; o < $scope.eloirasOptions.length; o++) {
          if (declarationId == $scope.eloirasOptions[o].id) {
            eloiras.selected = $scope.eloirasOptions[o];
          }
        }
      };

      $scope.refreshEloirasokByKezelesiEgyseg = function (modified, kezelesiEgyseg) {
        angular.forEach(modified, function (mod) {
          // ha "nem értékelt"-re rakta (korábban értékelt volt tehát)
          if (mod.selectedEloirasId == 12) {
            for (var a = 0; a < kezelesiEgyseg.ertekelt.length; a++) {
              if (kezelesiEgyseg.ertekelt[a].rule_code == mod.rule_code) {
                kezelesiEgyseg.ertekelt.splice(a, 1);
              }
            }
            // akkor adja hozzá, ha értékelte, és korábban nem volt értékelve (nincs benn az értékeltek listájában)
          } else {
            var isAlreadyErtekelt = false;
            for (var b = 0; b < kezelesiEgyseg.ertekelt.length; b++) {
              if (kezelesiEgyseg.ertekelt[b].rule_code == mod.rule_code) {
                isAlreadyErtekelt = true;
                break;
              }
            }
            if (!isAlreadyErtekelt) {
              kezelesiEgyseg.ertekelt.push(mod);
            }
          }
          for (var i = 0; i < $scope.selectedElements[0].eloirasok.length; i++) {
            var ke = $scope.selectedElements[0].eloirasok[i];
            if (ke.ke_kod == kezelesiEgyseg.ke_kod) {
              for (var j = 0; j < ke.children.length; j++) {
                var eloiras = ke.children[j];
                if (eloiras.rule_code == mod.rule_code) {
                  $scope.refreshEloirasColorByDeclarationId(mod.selectedEloirasId, eloiras);
                }
              }
            }
          }
        });
      };

      $scope.calculatePercent = function (ertekelt, children) {
        return parseInt(ertekelt.length / children.length * 100);
      };

      $scope.styleByPercent = function (ertekelt, children) {
        var percent = +$scope.calculatePercent(ertekelt, children);
        var bgcolor;
        var color;
        if (percent < 10) {
          bgcolor = "#FA9898";
          color = "#ed0c0c";
        } else if (percent < 20) {
          bgcolor = "#FAA690";
          color = "#e7380a";
        } else if (percent < 30) {
          bgcolor = "#F9B889";
          color = "#de640b";
        } else if (percent < 40) {
          bgcolor = "#F9CC81";
          color = "#d78a0a";
        } else if (percent < 50) {
          bgcolor = "#F8E37A";
          color = "#ceae0b";
        } else if (percent < 60) {
          bgcolor = "#F1F772";
          color = "#bcc50b";
        } else if (percent < 70) {
          bgcolor = "#D3F76B";
          color = "#90bf0a";
        } else if (percent < 80) {
          bgcolor = "#B2F664";
          color = "#66b60b";
        } else if (percent < 90) {
          bgcolor = "#8FF55D";
          color = "#41ae0b";
        } else {
          bgcolor = "#68f556";
          color = "#1ca80a";
        }
        return {
          "background-color": bgcolor,
          "color": "rgba(0, 0, 0, 0.8)",
          "padding-left": "2px",
          "padding-right": "2px",
          "font-style": "italic",
          "font-weight": "bold"
        };
      };

      $scope.openEloirasModal = function (size, kezelesiEgyseg, eloiras) {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'assets/terkep/app/modal/eloirasModal.html',
          controller: 'PggEloirasModalController',
          size: size,
          backdrop: 'static',
          resolve: {
            options: function () {
              return $scope.eloirasOptions;
            },
            kezelesiEgyseg: function () {
              return kezelesiEgyseg;
            },
            eloiras: function () {
              return eloiras;
            },
            userCanEdit: function () {
              return $scope.userCanEdit;
            }
          }
        });
        modalInstance.result.then(function (modified) {
          if (modified.length > 0) {
            pggEloirasProvider.putModifiedEloirasokPromise(modified).then(function (data) {
              if (data.status == 200 && data.statusText == "OK") {
                $scope.refreshEloirasokByKezelesiEgyseg(modified, kezelesiEgyseg);
              } else {
                $log.error("Hiba történt az előírások módosítása során");
                $log.error(data);
              }
            });
          }
        }, function () { });
      };

      /*****************************************************************
       * UPDATE, CANCEL, REMOVE
       ****************************************************************/
      this.update = function () {
        pggEditProvider.update($scope.selectedElements[0].feature, $scope.selectedElements[0].name, true);
        $scope.editForm.$setPristine();
      };

      this.cancel = function () {
        pggEditProvider.cancel($scope.selectedElements[0].feature, true, true);
        $scope.editForm.$setPristine();
      };

      this.remove = function (size) {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'assets/terkep/app/modal/deleteGeometryModal.html',
          controller: 'PggDeleteGeometryModalController',
          size: size,
          backdrop: 'static',
          resolve: {}
        });
        modalInstance.result.then(function () {
          pggEditProvider.remove($scope.selectedElements);
          $scope.alerts.push({
            type: 'success',
            msg: 'Az elem törlése sikerült.'
          });
        }, function () { });
      };

    }
  ]);
